const { getOffsetTop } = window.BAO.Utils

class TextReveal extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    /* eslint-disable-next-line no-undef */
    if (Shopify.designMode) return

    window.setTimeout(() => {
      this.setupWords()

      this.updateEl()
    }, 500)

    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)
  }

  disconnectedCallback () {
    window.removeEventListener('scroll', this.onScroll, { passive: true })
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  setupWords () {
    const wordsArray = this.els.original.element.innerText.split(' ')

    let buildContent = ''

    wordsArray.forEach(word => {
      buildContent += `<span class="sec-TextReveal_Word" data-text-reveal-el="word">${word}</span> `
    })

    this.els.overlay.element.innerHTML = buildContent
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.revealText()
  }

  revealText () {
    const containerOffsetTop = getOffsetTop(this)
    const paddingBlock = parseFloat(
      window.getComputedStyle(this, null).getPropertyValue('padding-block'),
    )

    const elementStartPoint =
      containerOffsetTop - window.innerHeight + this.offsetHeight - paddingBlock
    const elementEndPoint =
      containerOffsetTop - this.style.paddingBottom - paddingBlock

    const wordEls = this.querySelectorAll(this.els?.word?.selector)
    if (!wordEls.length) return

    if (
      this.lastKnownY <= elementStartPoint ||
      this.lastKnownY > elementEndPoint
    ) {
      const value = this.lastKnownY <= elementStartPoint ? '0%' : '100%'
      wordEls.forEach(wordEl =>
        wordEl.style.setProperty('--Reveal_Amount', value),
      )
      return
    }

    const scrollProgress =
      (this.lastKnownY - elementStartPoint) /
      (elementEndPoint - elementStartPoint)
    const totalWords = wordEls.length

    wordEls.forEach((wordEl, index) => {
      const minPercent = index / totalWords
      const maxPercent = (index + 1) / totalWords

      if (scrollProgress >= maxPercent) {
        wordEl.style.setProperty('--Reveal_Amount', '100%')
      } else if (scrollProgress < minPercent) {
        wordEl.style.setProperty('--Reveal_Amount', '0%')
      } else {
        const wordProgress =
          (scrollProgress - minPercent) / (maxPercent - minPercent)
        const wordProgressAmount = Math.round(wordProgress * 1000) / 10

        wordEl.style.setProperty('--Reveal_Amount', `${wordProgressAmount}%`)
      }
    })
  }
}

if (!customElements.get('text-reveal')) {
  customElements.define('text-reveal', TextReveal)
}
